<div class="auto-summary" (click)="emitOpenDetail()">
  <div class="container">
    <div class="header">
      <div class="main">
        <div class="title">
          <img class="logo" [src]="logo_url" />
          <span class="model">{{ model }}</span>
        </div>
        <app-auto-info-view [data]="info"></app-auto-info-view>
      </div>
      <i aria-hidden="true" class="icon-expand"></i>
    </div>
    <div class="places">
      <div class="place pickup">
        <h4>{{ 'AUTOS_MODULE.DETAILS.PICKUP' | transloco }}:</h4>
        <p class="datetime">{{ pickUp }} • {{ pickUpTime }}</p>
        <p class="address">{{ pickUpPlace }}</p>
      </div>
      <div class="place dropoff">
        <h4>{{ 'AUTOS_MODULE.DETAILS.DROPOFF' | transloco }}:</h4>
        <p class="datetime">{{ dropOff }} • {{ dropOffTime }}</p>
        <p class="address">{{ dropOffPlace }}</p>
      </div>
    </div>
  </div>
</div>
